module.exports = __webpack_public_path__ + "img/netjets.a70d02f9.png";